var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { attrs: { "align-h": "center", "align-v": "center" } },
        [
          _c(
            "b-col",
            { staticClass: "col-md-10" },
            [
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col", { staticClass: "text-left" }, [
                    _vm.ocorrencia.id
                      ? _c("h3", [
                          _vm._v(" Ocorrencia nº " + _vm._s(_vm.ocorrencia.id))
                        ])
                      : _c("h3", [_vm._v("Nova Ocorrência")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary", size: "sm" },
                          on: {
                            click: function($event) {
                              return _vm.voltar()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-list" }),
                          _vm._v(" Listar Ocorrências\n          ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                [
                  _vm.ocorrencia.id
                    ? _c(
                        "b-card-header",
                        { class: _vm.getClass },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c("h4", [
                                  _c("p", [
                                    _c("b", [
                                      _vm._v(_vm._s(_vm.tipoOcorrencia))
                                    ])
                                  ])
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-2" },
                            [
                              _c("b-col", [
                                _c("p", [
                                  _c("b", [_vm._v(" Código da Ocorrência:")]),
                                  _vm._v(" " + _vm._s(_vm.ocorrencia.id))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-col", [
                                _c("p", [
                                  _c("b", [_vm._v(" Status:")]),
                                  _vm._v(" " + _vm._s(_vm.getStatus))
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-2" },
                            [
                              _c("b-col", { attrs: { cols: "9" } }, [
                                _c("p", [
                                  _c("b", [_vm._v(" Distribuidor: ")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.ocorrencia.distribuidor.codigo
                                      ) +
                                      " - " +
                                      _vm._s(_vm.ocorrencia.distribuidor.nome) +
                                      " "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.ocorrencia.enviar_para
                                ? _c("b-col", [
                                    _c("p", [
                                      _c("b", [_vm._v("Enviar Para:")]),
                                      _vm._v(
                                        " " + _vm._s(_vm.ocorrencia.enviar_para)
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.ocorrencia.revendedora &&
                          _vm.ocorrencia.revendedora.nome
                            ? _c(
                                "b-row",
                                { staticClass: "mt-2" },
                                [
                                  _c("b-col", [
                                    _c("p", [
                                      _c("b", [_vm._v("Revendedora: ")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.ocorrencia.revendedora
                                              ? _vm.ocorrencia.revendedora.nome
                                              : ""
                                          ) +
                                          " "
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-2" },
                            [
                              _c("b-col", { staticClass: "col-md-2" }, [
                                _c("p", [
                                  _c("b", [_vm._v("Lote:")]),
                                  _vm._v(
                                    " " + _vm._s(_vm.ocorrencia.lote.codigo)
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-col", { staticClass: "text-right" }, [
                                _c("p", [
                                  _c("b", [_vm._v(" Abertura:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatarData(
                                          _vm.ocorrencia.created_at
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-col", { staticClass: "text-right" }, [
                                _c("p", [
                                  _c("b", [_vm._v(" Última Atualização:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatarData(
                                          _vm.ocorrencia.updated_at
                                        )
                                      )
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-card-body",
                    [
                      _c("v-mensagens", {
                        staticClass: "mt-3",
                        attrs: { ocorrenciaProps: _vm.ocorrencia }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d89e08a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d89e08a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ocorrencia/Edit.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2d89e08a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ocorrencia/Edit.vue
// module chunks = 2